/* Product page: options, add to cart, gallery, sticky bar, lightbox. */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  var data = JSON.parse(root.querySelector('[data-product-json]').textContent);
  var optionEls = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
  var addButton = root.querySelector('[data-add]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceEl = root.querySelector('[data-price]');
  var soldOutEl = root.querySelector('[data-soldout]');
  var sticky = document.querySelector('[data-sticky]');
  var stickyAdd = document.querySelector('[data-sticky-add]');
  var stickyMeta = document.querySelector('[data-sticky-meta]');
  var money = (window.asTheme && window.asTheme.money) || function (c) { return '$' + (c / 100).toFixed(2); };

  /* ---------- Options ---------- */

  var selected = data.options.map(function () { return null; });
  var preselect = root.getAttribute('data-preselect') === 'true';
  var initialId = idInput && idInput.value ? Number(idInput.value) : null;
  if (preselect && initialId) {
    var initial = data.variants.filter(function (v) { return v.id === initialId; })[0];
    if (initial) selected = initial.options.slice();
  }
  // An option with a single value is chosen for the shopper.
  optionEls.forEach(function (el, i) {
    var values = el.querySelectorAll('[data-option-value]');
    if (values.length === 1) selected[i] = values[0].getAttribute('data-option-value');
  });

  function matches(variant, choice) {
    return choice.every(function (value, i) { return value === null || variant.options[i] === value; });
  }

  function currentVariant() {
    if (selected.some(function (v) { return v === null; })) return null;
    return data.variants.filter(function (v) { return matches(v, selected); })[0] || null;
  }

  function render() {
    optionEls.forEach(function (el, i) {
      el.querySelectorAll('[data-option-value]').forEach(function (button) {
        var value = button.getAttribute('data-option-value');
        var choice = selected.slice();
        choice[i] = value;
        var candidates = data.variants.filter(function (v) { return matches(v, choice); });
        var exists = candidates.length > 0;
        var available = candidates.some(function (v) { return v.available; });
        button.classList.toggle('is-selected', selected[i] === value);
        button.classList.toggle('is-unavailable', exists && !available);
        button.disabled = !exists || !available;
        button.setAttribute('aria-label', available ? value : value + ' sold out');
      });
    });

    var variant = currentVariant();
    var canAdd = Boolean(variant && variant.available);
    if (idInput) idInput.value = variant ? variant.id : '';
    if (addButton) addButton.disabled = !canAdd;
    if (stickyAdd) stickyAdd.disabled = false;
    if (soldOutEl) soldOutEl.hidden = !(variant && !variant.available);
    if (priceEl && variant) priceEl.textContent = money(variant.price);
    if (stickyMeta) {
      var price = money(variant ? variant.price : data.variants[0].price);
      var picked = data.options.map(function (name, i) { return selected[i] ? name + ' ' + selected[i] : null; }).filter(Boolean);
      stickyMeta.textContent = price + (variant && picked.length && optionEls.length === 1 ? ' · ' + picked.join(', ') : '');
    }
  }

  optionEls.forEach(function (el, i) {
    el.addEventListener('click', function (event) {
      var button = event.target.closest('[data-option-value]');
      if (!button || button.disabled) return;
      selected[i] = button.getAttribute('data-option-value');
      render();
    });
  });

  function promptForOption() {
    var missing = optionEls.filter(function (el, i) { return selected[i] === null; })[0] || optionEls[0];
    if (!missing) return;
    missing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    missing.classList.add('is-highlighted');
    setTimeout(function () { missing.classList.remove('is-highlighted'); }, 1600);
  }

  function add(button) {
    var variant = currentVariant();
    if (!variant) { promptForOption(); return; }
    if (!variant.available || !window.asTheme) return;
    button.disabled = true;
    window.asTheme.addToCart([{ id: variant.id, quantity: 1 }])
      .catch(function (error) { window.asTheme.toast(error.message || 'Could not add to cart'); })
      .finally(render);
  }

  if (addButton) addButton.addEventListener('click', function () { add(addButton); });
  if (stickyAdd) stickyAdd.addEventListener('click', function () { add(stickyAdd); });

  render();

  /* ---------- Sticky bar on phones, once the main button scrolls away ---------- */

  var buy = root.querySelector('[data-buy]');
  if (sticky && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0 }).observe(buy);
  }

  /* ---------- Gallery ---------- */

  var gallery = root.querySelector('[data-gallery]');
  var track = gallery && gallery.querySelector('[data-gallery-track]');
  if (track) {
    var slides = track.children.length;
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    var index = function () { return Math.round(track.scrollLeft / track.clientWidth); };
    var go = function (i) {
      var target = (i + slides) % slides;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
    };
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(Number(dot.getAttribute('data-gallery-dot'))); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = index();
        dots.forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  }

  // Phones block autoplay until a first touch; start muted videos then.
  var videos = root.querySelectorAll('video');
  var playAll = function () {
    videos.forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  };
  if (videos.length) {
    playAll();
    window.addEventListener('pointerdown', playAll, { passive: true, once: true });
    window.addEventListener('touchstart', playAll, { passive: true, once: true });
  }

  /* ---------- Lightbox for the detail photos ---------- */

  var lightbox = document.querySelector('[data-lightbox-view]');
  if (lightbox) {
    var img = lightbox.querySelector('[data-lightbox-img]');
    root.addEventListener('click', function (event) {
      var tile = event.target.closest('[data-lightbox]');
      if (!tile) return;
      img.src = tile.getAttribute('data-lightbox');
      lightbox.hidden = false;
    });
    lightbox.addEventListener('click', function () { lightbox.hidden = true; img.removeAttribute('src'); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') lightbox.hidden = true;
    });
  }
})();
